import React, { useState } from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import InlineSVG from "ComponentsUI/Inlinesvg";
import { Tooltip, TooltipHeader, TooltipBody } from "ComponentsUI/Tooltip";

const styles = (theme) => ({
	root: {
		width: "100%",
	},
	wrapper: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		justifyContent: "center",
	},
	more: {},
	item: {
		"& svg": {
			width: "24px",
			height: "24px",
			fill: theme.palette.colors.purplishBlue,
			"& .cls-1": {
				fill: theme.palette.colors.purplishBlue,
			},
		},
	},
	itemMore: {
		marginRight: "5px",
		marginLeft: "5px",
		marginBottom: "5px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"font-family": "MuseoSansCyrl-700",
		"font-size": "12px",
		"line-height": "0.83",
		color: "#c0bbd3",
		"border-radius": "6px",
		border: "solid 2px #d3cee1",
		width: "24px",
		height: "24px",
		cursor: "pointer",
	},
	itemWrapper: {
		marginRight: "5px",
		marginLeft: "5px",
		marginBottom: "5px",
		display: "block",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		wrapper: {
			justifyContent: "center",
		},
	},
});

const Component = ({ classes, items, limit, onClickMoreHandler }) => {
	const [hideIcons, setHideIcons] = useState(true);

	const onClickHandler = () => {
		setHideIcons(false);
		!!onClickMoreHandler && onClickMoreHandler();
	};

	const preventBehavior = (e) => {
		e.stopPropagation();
	};

	const generateDodys = () => {
		let invisibleDody = [];
		if (items) {
			invisibleDody = items.slice(limit);
			let moreDody = items.length > limit + 1;
			let dodys = hideIcons && items.length > limit + 1 ? items.slice(0, limit) : items;

			return (
				<div
					className={classNames(classes.wrapper, {
						[classes.more]: moreDody,
					})}
				>
					{dodys.map((item, index) => {
						let textTooltip = "";
						textTooltip = item.short_description || "";
						textTooltip = (
							<div
								dangerouslySetInnerHTML={{
									__html: textTooltip,
								}}
							/>
						);
						return (
							<div key={index} className={classes.item}>
								<Tooltip
									header={<TooltipHeader text={item.name} />}
									body={<TooltipBody>{textTooltip}</TooltipBody>}
								>
									<InlineSVG
										className={classes.itemWrapper}
										src={
											item.image_24px ||
											"//static.101internet.ru/images/new_tv/languages/1490015649.svg"
										}
									>
										<svg width="24" height="20">
											<image xlinkHref={item.image_24px} width="24" height="20" />
										</svg>
									</InlineSVG>
								</Tooltip>
							</div>
						);
					})}
					{invisibleDody.length && hideIcons && items.length > limit + 1 ? (
						<div className={classes.itemMore} onClick={onClickHandler}>
							{" "}
							{`+${invisibleDody.length}`}{" "}
						</div>
					) : null}
				</div>
			);
		} else {
			return null;
		}
	};

	return (
		<div className={classes.root} onClick={preventBehavior}>
			{generateDodys()}
		</div>
	);
};

const DodyList = withStyles(styles)(Component);
DodyList.displayName = "DodyList";

export default DodyList;
